import React, { useMemo } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { templateRoute } from "../Utilities";

export const useNavigation = () => {
  const { pathname } = useLocation();
  const navigates = useNavigate();
  const path = useMemo(() => {
    const _pathName = pathname.split("/");
    if (_pathName.length > 3) return _pathName.slice(0, 3)?.join("/") || "";
    else return _pathName.slice(0, 2)?.join("/") || "";
  }, [pathname]);

  function _navigate(route: string) {
    return navigates(`${path}/${route}`);
  }
  function _navigateWithParams(route: string, param: any) {
    if (path) return navigates(`${path}/` + templateRoute(route, param));
    else return navigates(templateRoute(route, param));
  }
  return { path, _navigate, _navigateWithParams };
};
